import { createFileRoute } from '@tanstack/react-router';
import { ProductDetailScreen } from '../../../features/products/components/ProductDetailScreen';

/** Product detail / "Stock Enquiry" parity (BUILD_SPEC.md §13 amendment,
 * 2026-08-26). */
export const Route = createFileRoute('/_authenticated/products/$productId')({
  component: ProductDetailPage,
});

function ProductDetailPage() {
  const { productId } = Route.useParams();
  return <ProductDetailScreen productId={productId} />;
}
